/* LVNG nieuwe look — interactie */
(function () {
  'use strict';
  var ICONS = {
    plus: '<path d="M5 12h14"/><path d="M12 5v14"/>',
    minus: '<path d="M5 12h14"/>',
    trash: '<path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/>',
    pause: '<rect x="14" y="4" width="4" height="16" rx="1"/><rect x="6" y="4" width="4" height="16" rx="1"/>',
    play: '<path d="M6 3v18l14-9Z"/>'
  };
  function svg(n) { return '<span class="lv-i" aria-hidden="true"><svg viewBox="0 0 24 24" focusable="false">' + (ICONS[n] || '') + '</svg></span>'; }
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  function money(cents) {
    try { return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: currency }).format(cents / 100).replace(/\s/g, ''); }
    catch (e) { return '€' + (cents / 100).toFixed(2).replace('.', ','); }
  }
  function cfg() { var el = $('[data-lv-config]'); try { return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; } }
  var CONFIG = cfg();
  var FREE = (CONFIG.freeShipping || 3500);

  /* ---------- Panelen ---------- */
  var lastFocus = null;
  function openPanel(name) {
    var panel = document.getElementById('lv-' + name);
    if (!panel) return false;
    closePanels(false);
    lastFocus = document.activeElement;
    panel.hidden = false;
    var scrim = $('.lv-scrim'); if (scrim) scrim.hidden = false;
    document.body.classList.add('lv-locked');
    requestAnimationFrame(function () { panel.classList.add('lv-open'); });
    var f = panel.querySelector('input, button');
    if (f) setTimeout(function () { f.focus(); }, 50);
    return true;
  }
  function closePanels(restore) {
    $$('.lv-panel').forEach(function (p) { p.classList.remove('lv-open'); p.hidden = true; });
    var scrim = $('.lv-scrim'); if (scrim) scrim.hidden = true;
    document.body.classList.remove('lv-locked');
    var bd = document.querySelector('cart-drawer, #cart-drawer');
    if (bd) { var bc = bd.querySelector('[data-drawer-close], [data-close-drawer], .drawer__close, button[aria-label*="lu"]'); if (bc) { try { bc.click(); } catch (err) {} } }
    document.body.style.overflow = ''; document.body.style.paddingRight = '';
    if (restore !== false && lastFocus && lastFocus.focus) lastFocus.focus();
  }
  var toastTimer;
  function toast(msg) {
    var el = $('.lv-toast'); if (!el) return;
    el.textContent = msg; el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 4000);
  }

  /* ---------- Winkelmand (Shopify AJAX API) ---------- */
  function getCart() { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function renderCart(cart) {
    var list = $('#lv-cart-lines'); if (!list) return;
    var html = cart.items.map(function (item) {
      var opts = (item.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; }).map(function (o) { return '<span>' + esc(o.value) + '</span>'; }).join('');
      var img = item.image ? '<img class="lv-wit-bg" src="' + esc(item.image) + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" width="72" height="72" loading="lazy">' : '<span></span>';
      return '<li class="lv-line" data-key="' + esc(item.key) + '">' + '<a href="' + esc(item.url) + '">' + img + '</a>' +
        '<div><a class="lv-line-name" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
        '<p class="lv-line-sub">' + opts + '<span>' + money(item.final_line_price) + '</span></p>' +
        '<div class="lv-qty lv-qty-s"><button type="button" data-qty="' + esc(item.key) + '" data-d="-1" aria-label="Eén minder">' + svg('minus') + '</button><span>' + item.quantity + '</span><button type="button" data-qty="' + esc(item.key) + '" data-d="1" aria-label="Eén meer">' + svg('plus') + '</button></div>' +
        '</div><button class="lv-line-del" type="button" data-del="' + esc(item.key) + '" aria-label="Verwijder ' + esc(item.product_title) + '">' + svg('trash') + '</button></li>';
    }).join('');
    list.innerHTML = html || '<li class="lv-cart-empty">' + esc(CONFIG.emptyText || 'Je winkelmand is nog leeg. Begin bij je favoriete geur.') + '</li>';
    var sub = $('#lv-cart-subtotal'); if (sub) sub.textContent = money(cart.total_price);
    var rest = FREE - cart.total_price;
    var st = $('#lv-ship-text'); if (st) st.textContent = rest > 0 ? 'Nog ' + money(rest) + ' tot gratis verzending' : 'Je bestelling wordt gratis verzonden';
    var bar = $('#lv-ship-bar'); if (bar) bar.style.width = Math.min(100, (cart.total_price / FREE) * 100) + '%';
    $$('[data-lv-count]').forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
    var foot = $('#lv-cart-foot'); if (foot) foot.hidden = cart.item_count === 0;
    document.querySelectorAll('cart-count').forEach(function (el) { el.textContent = cart.item_count; });
  }
  function refreshCart() { return getCart().then(renderCart).catch(function () {}); }
  function addToCart(id, qty, btn) {
    if (btn) btn.classList.add('is-loading');
    return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-LVNG': '1' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return getCart(); })
      .then(function (cart) { renderCart(cart); if (!openPanel('cart')) toast('Toegevoegd aan je winkelmand'); })
      .catch(function (err) { toast((err && (err.description || err.message)) || 'Toevoegen lukte niet, probeer het opnieuw.'); })
      .then(function () { if (btn) btn.classList.remove('is-loading'); });
  }
  function changeLine(key, qty) {
    return fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(renderCart)
      .catch(function () { toast('Aanpassen lukte niet, probeer het opnieuw.'); });
  }
  function lineQty(key) { var li = document.querySelector('.lv-line[data-key="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"] .lv-qty span:not(.lv-i)'); return li ? Number(li.textContent) : 1; }

  /* ---------- Favorieten (lokaal, per bezoeker) ---------- */
  var FAV_KEY = 'lvng-fav';
  var favs = [];
  try { favs = JSON.parse(localStorage.getItem(FAV_KEY)) || []; } catch (e) { favs = []; }
  function paintFavs() { $$('[data-fav]').forEach(function (b) { b.setAttribute('aria-pressed', String(favs.indexOf(b.getAttribute('data-fav')) > -1)); }); }

  /* ---------- Kliks ---------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('.lv-scrim')) { closePanels(); return; }
    var el = e.target.closest('button, a');
    if (!el || !el.closest('.lv-root')) {
      if (!e.target.closest('.lv-spot-pop')) $$('.lv-spot[aria-expanded="true"]').forEach(function (s) { s.setAttribute('aria-expanded', 'false'); });
      return;
    }
    var d = el.dataset;
    if (d.open) { if (openPanel(d.open)) e.preventDefault(); }
    if ('close' in d) closePanels();
    if (d.add) { e.preventDefault(); addToCart(d.add, 1, el); }
    if (d.qty) { var n = lineQty(d.qty) + Number(d.d); changeLine(d.qty, Math.max(0, n)); }
    if (d.del) changeLine(d.del, 0);
    if (d.fav) {
      var h = d.fav; var i = favs.indexOf(h);
      if (i > -1) favs.splice(i, 1); else favs.push(h);
      try { localStorage.setItem(FAV_KEY, JSON.stringify(favs)); } catch (err) {}
      paintFavs();
      toast(i > -1 ? 'Verwijderd uit je favorieten' : 'Bewaard in je favorieten');
    }
    if (d.tab) switchTab(el);
    if (el.classList.contains('lv-spot')) {
      var open = el.getAttribute('aria-expanded') === 'true';
      $$('.lv-spot').forEach(function (s) { s.setAttribute('aria-expanded', 'false'); });
      el.setAttribute('aria-expanded', String(!open));
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closePanels();
    $$('.lv-spot').forEach(function (s) { s.setAttribute('aria-expanded', 'false'); });
  });

  /* ---------- Tabs met productlijsten ---------- */
  function switchTab(btn) {
    var sec = btn.closest('.lv-tabs-sec'); if (!sec) return;
    var key = btn.getAttribute('data-tab');
    $$('[data-tab]', sec).forEach(function (t) { t.setAttribute('aria-selected', String(t === btn)); });
    $$('[data-tab-text]', sec).forEach(function (p) { p.hidden = p.getAttribute('data-tab-text') !== key; });
    $$('[data-tab-link]', sec).forEach(function (p) { p.hidden = p.getAttribute('data-tab-link') !== key; });
    $$('[data-tab-list]', sec).forEach(function (l) { l.hidden = l.getAttribute('data-tab-list') !== key; if (!l.hidden) { l.scrollLeft = 0; updateIndicator(l); } });
  }
  function updateIndicator(track) {
    var wrap = track.parentElement; var ind = wrap && wrap.querySelector('.lv-indicator'); if (!ind) return;
    var bar = ind.querySelector('i');
    if (!track.scrollWidth) return;
    var ratio = track.clientWidth / track.scrollWidth;
    var max = track.scrollWidth - track.clientWidth;
    bar.style.width = Math.min(100, ratio * 100) + '%';
    bar.style.transform = 'translateX(' + (max > 0 ? (track.scrollLeft / max) * ((1 / ratio) - 1) * 100 : 0) + '%)';
    ind.hidden = ratio >= 0.99;
  }
  function initTracks() {
    $$('.lv-track').forEach(function (t) {
      if (t.__lv) return; t.__lv = 1;
      t.addEventListener('scroll', function () { updateIndicator(t); }, { passive: true });
      updateIndicator(t);
    });
  }
  window.addEventListener('resize', function () { $$('.lv-track').forEach(updateIndicator); });

  /* ---------- Aankondiging ---------- */
  function initAnnounce() {
    $$('.lv-announce').forEach(function (bar) {
      if (bar.__lv) return; bar.__lv = 1;
      var items = $$('.lv-announce-msg', bar); if (items.length < 2) return;
      var i = 0;
      function show(n) { i = (n + items.length) % items.length; items.forEach(function (m, k) { m.hidden = k !== i; }); }
      var p = $('.lv-announce-prev', bar), n = $('.lv-announce-next', bar);
      if (p) p.addEventListener('click', function () { show(i - 1); });
      if (n) n.addEventListener('click', function () { show(i + 1); });
      if (!reduceMotion) setInterval(function () { show(i + 1); }, 5000);
    });
  }

  /* ---------- Hero ---------- */
  function initHero() {
    $$('.lv-hero').forEach(function (hero) {
      if (hero.__lv) return; hero.__lv = 1;
      var slides = $$('.lv-slide', hero); if (!slides.length) return;
      var dots = $$('.lv-hero-dot', hero); var pause = $('.lv-hero-pause', hero);
      var i = 0, timer = null, speed = Number(hero.getAttribute('data-speed') || 6) * 1000;
      function show(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('lv-on', k === i); s.setAttribute('aria-hidden', String(k !== i)); s.inert = k !== i; });
        dots.forEach(function (d, k) { d.setAttribute('aria-current', String(k === i)); });
      }
      function play() { if (slides.length < 2) return; timer = setInterval(function () { show(i + 1); }, speed); if (pause) { pause.innerHTML = svg('pause'); pause.setAttribute('aria-label', 'Pauzeer slider'); } }
      function stop() { clearInterval(timer); timer = null; if (pause) { pause.innerHTML = svg('play'); pause.setAttribute('aria-label', 'Speel slider af'); } }
      dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); }); });
      if (pause) pause.addEventListener('click', function () { if (timer) stop(); else play(); });
      hero.addEventListener('click', function (e) { if (e.target.closest('.lv-spot') && timer) stop(); });
      show(0);
      if (reduceMotion || hero.getAttribute('data-autoplay') === 'false') stop(); else play();
    });
  }

  /* ---------- Reviews ---------- */
  function initReviews() {
    $$('.lv-reviews').forEach(function (sec) {
      if (sec.__lv) return; sec.__lv = 1;
      var quotes = $$('.lv-review', sec); var dots = $$('.lv-review-dot', sec);
      function show(n) { quotes.forEach(function (q, k) { q.hidden = k !== n; }); dots.forEach(function (d, k) { d.setAttribute('aria-current', String(k === n)); }); }
      dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); }); });
      if (quotes.length) show(0);
    });
  }

  /* ---------- Zoeken (predictive search) ---------- */
  function initSearch() {
    var input = $('#lv-search-input'); var out = $('#lv-search-results');
    if (!input || !out || input.__lv) return; input.__lv = 1;
    var initial = out.innerHTML; var t;
    input.addEventListener('input', function () {
      clearTimeout(t);
      var q = input.value.trim();
      if (!q) { out.innerHTML = initial; return; }
      t = setTimeout(function () {
        fetch(root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8')
          .then(function (r) { return r.json(); })
          .then(function (j) {
            var ps = (j.resources && j.resources.results && j.resources.results.products) || [];
            out.innerHTML = ps.length ? ps.map(function (p) {
              var img = p.image ? '<img class="lv-wit-bg" src="' + esc(p.image) + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" width="48" height="48">' : '';
              return '<li><a href="' + esc(p.url) + '">' + img + '<span>' + esc(p.title) + '</span><b>' + money(Math.round(parseFloat(p.price) * 100)) + '</b></a></li>';
            }).join('') : '<li class="lv-cart-empty">Geen product gevonden. Probeer een geur, zoals Casablanca.</li>';
          }).catch(function () {});
      }, 180);
    });
    var form = input.closest('form');
    if (form) form.addEventListener('submit', function (e) { if (!input.value.trim()) e.preventDefault(); });
  }

  /* ---------- Productpagina ---------- */
  function initProduct() {
    var pdp = $('.lv-pdp'); if (!pdp || pdp.__lv) return; pdp.__lv = 1;
    var gal = $('.lv-gal', pdp);
    var qty = 1; var qv = $('#lv-qty-val');
    function setQty(n) { qty = Math.max(1, Math.min(99, n)); if (qv) qv.textContent = qty; }
    var mn = $('#lv-qty-min'), pl = $('#lv-qty-plus');
    if (mn) mn.addEventListener('click', function () { setQty(qty - 1); });
    if (pl) pl.addEventListener('click', function () { setQty(qty + 1); });
    var form = $('#lv-product-form');
    function currentVariant() { var c = form && form.querySelector('[name="id"]:checked, select[name="id"], input[type="hidden"][name="id"]'); return c ? c.value : null; }
    var variants = []; try { variants = JSON.parse(($('#lv-variants') || {}).textContent || '[]'); } catch (e) {}
    function syncVariant() {
      var id = Number(currentVariant()); var v = variants.filter(function (x) { return x.id === id; })[0]; if (!v) return;
      var price = $('#lv-pdp-price'); if (price) price.innerHTML = money(v.price) + (v.compare_at_price > v.price ? ' <s>' + money(v.compare_at_price) + '</s>' : '');
      var sp = $('#lv-sticky-price'); if (sp) sp.textContent = money(v.price);
      $$('[data-add-current]').forEach(function (b) { b.disabled = !v.available; b.textContent = v.available ? 'in winkelmand' : 'uitverkocht'; });
      if (v.featured_media && gal) { var slide = gal.querySelector('[data-media-id="' + v.featured_media.id + '"]'); if (slide) gal.scrollTo({ left: slide.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' }); }
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); } catch (e) {}
    }
    if (form) form.addEventListener('change', syncVariant);
    $$('[data-add-current]').forEach(function (b) { b.addEventListener('click', function () { var id = currentVariant(); if (id) addToCart(id, qty, b).then(function () { setQty(1); }); }); });
    if (gal) {
      var dots = $$('.lv-gal-dot', pdp);
      dots.forEach(function (d, k) { d.addEventListener('click', function () { gal.scrollTo({ left: gal.clientWidth * k, behavior: reduceMotion ? 'auto' : 'smooth' }); }); });
      gal.addEventListener('scroll', function () { var idx = Math.round(gal.scrollLeft / gal.clientWidth); dots.forEach(function (d, k) { d.setAttribute('aria-current', String(k === idx)); }); }, { passive: true });
      var zoom = $('#lv-gal-zoom');
      if (zoom) zoom.addEventListener('click', function () {
        var idx = Math.round(gal.scrollLeft / gal.clientWidth); var img = $$('img', gal)[idx]; if (!img) return;
        var z = $('#lv-zoom-img'); z.src = img.getAttribute('data-zoom') || img.currentSrc || img.src; z.alt = img.alt; openPanel('zoom');
      });
    }
    var sticky = $('.lv-sticky-buy'); var row = $('#lv-buy-row');
    if (sticky && row && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { sticky.classList.toggle('lv-show', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(row);
    }
  }
  function initNotes() {
    $$('.lv-notes-sec').forEach(function (sec) {
      if (sec.__lv) return; sec.__lv = 1;
      var tabs = $$('[data-note]', sec); var label = $('.lv-notes-label', sec); var text = $('.lv-notes-text', sec);
      tabs.forEach(function (b) { b.addEventListener('click', function () {
        tabs.forEach(function (t) { t.setAttribute('aria-selected', String(t === b)); });
        if (label) label.textContent = b.getAttribute('data-label');
        if (text) text.textContent = b.getAttribute('data-text');
      }); });
    });
  }

  /* ---------- Footer accordeons mobiel ---------- */
  function initFooter() {
    if (window.matchMedia('(max-width: 767px)').matches) $$('.lv-foot-col').forEach(function (d) { d.removeAttribute('open'); });
  }

  /* ---------- Video's: afspelen in beeld, geluid aan/uit ---------- */
  var SOUND_OFF = '<span class="lv-i" aria-hidden="true"><svg viewBox="0 0 24 24" focusable="false"><path d="M11 5 6 9H2v6h4l5 4V5Z"/><path d="m22 9-6 6"/><path d="m16 9 6 6"/></svg></span>';
  var SOUND_ON = '<span class="lv-i" aria-hidden="true"><svg viewBox="0 0 24 24" focusable="false"><path d="M11 5 6 9H2v6h4l5 4V5Z"/><path d="M15.54 8.46a5 5 0 0 1 0 7.07"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14"/></svg></span>';
  function initVideos() {
    var vids = $$('.lv-video-card video');
    vids.forEach(function (v) {
      if (v.__lv) return; v.__lv = 1;
      v.muted = true; v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.loop = true;
      var btn = v.parentElement.querySelector('.lv-video-sound');
      if (btn) btn.addEventListener('click', function () {
        var on = v.muted;
        vids.forEach(function (o) { if (o !== v) { o.muted = true; var b = o.parentElement.querySelector('.lv-video-sound'); if (b) { b.innerHTML = SOUND_OFF; b.setAttribute('aria-pressed', 'false'); b.setAttribute('aria-label', 'Geluid aan'); } } });
        v.muted = !on;
        btn.innerHTML = on ? SOUND_ON : SOUND_OFF;
        btn.setAttribute('aria-pressed', String(on));
        btn.setAttribute('aria-label', on ? 'Geluid uit' : 'Geluid aan');
        if (on) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
      });
    });
    if (reduceMotion || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) { if (v.preload === 'none') v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else { v.pause(); }
      });
    }, { threshold: 0.35 });
    vids.forEach(function (v) { io.observe(v); });
  }

  /* ---------- Productfoto's: pijltjes ---------- */
  function initGalArrows() {
    $$('.lv-gal-wrap').forEach(function (wrap) {
      if (wrap.__lv) return; wrap.__lv = 1;
      var gal = wrap.querySelector('.lv-gal'); var prev = wrap.querySelector('.lv-gal-prev'); var next = wrap.querySelector('.lv-gal-next');
      if (!gal || !prev || !next) return;
      function go(d) { gal.scrollTo({ left: gal.scrollLeft + d * gal.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' }); }
      function upd() { var max = gal.scrollWidth - gal.clientWidth - 2; prev.disabled = gal.scrollLeft <= 2; next.disabled = gal.scrollLeft >= max; }
      prev.addEventListener('click', function () { go(-1); });
      next.addEventListener('click', function () { go(1); });
      gal.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    });
  }

  /* ---------- Collectietekst: 'lees meer' bovenaan opent de tekst onderaan ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('.lv-coll-more'); if (!a) return;
    var sec = document.getElementById('lv-coll-seo'); if (!sec) return;
    e.preventDefault();
    var d = sec.querySelector('details'); if (d) d.open = true;
    var hd = document.querySelector('.lv-header'); var off = (hd ? hd.getBoundingClientRect().height : 80) + 24;
    window.scrollTo({ top: sec.getBoundingClientRect().top + window.pageYOffset - off, behavior: reduceMotion ? 'auto' : 'smooth' });
  });

  function init() {
    initVideos(); initGalArrows();
    initTracks(); initAnnounce(); initHero(); initReviews(); initSearch(); initProduct(); initNotes(); initFooter(); paintFavs();
    if ($('#lv-cart-lines')) refreshCart();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { init(); });
  /* Andere winkelmand-acties van het thema (bijv. snel toevoegen op collectiepagina's) openen ook de LVNG-winkelmand */
  if (window.fetch && !window.__lvFetch) {
    window.__lvFetch = true;
    var _f = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      var p = _f.apply(this, arguments);
      if (method === 'POST' && /\/cart\/add/.test(url) && !(init && init.headers && init.headers['X-LVNG'])) {
        p.then(function (r) { if (r.ok) setTimeout(function () { refreshCart().then(function () { openPanel('cart'); }); }, 50); }).catch(function () {});
      }
      return p;
    };
  }
  window.LVNG = { openPanel: openPanel, addToCart: addToCart, refreshCart: refreshCart };
})();
